import {
  requestContactList,
  requestSaveContact,
} from '@/api/contact';

const state = {
  contactList: null,
  currentContact: null,
  saveContactResult: null,
};

const getters = {
  contactList: (state) => state.contactList,
  currentContact: (state) => state.currentContact,
  saveContactResult: (state) => state.saveContactResult,
};

const actions = {
  async setContactList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestContactList({ pageNumber });
    commit('setContactList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  clearCurrentContact({ commit }) {
    commit('setCurrentContact', null);
  },
  async saveContact({ commit, dispatch, rootGetters }, { postParams, id }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrfResult;
    const result = await requestSaveContact({ csrfToken, postParams, id });
    commit('setSaveContact', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearSaveContactResult({ commit }) {
    commit('setSaveContact', null);
  },
};

const mutations = {
  setContactList(state, contactList) {
    state.contactList = contactList;
  },
  setSaveContact(state, saveContactResult) {
    state.saveContactResult = saveContactResult;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
